import React, { useState } from "react";
import { Col, Modal, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import FormToggle from "components/FormToggle/FormToggle";

import AddLoanModal from "../AddLoanModal/AddLoanModal";
import LoanCard from "../LoanCard/LoanCard";

import { AddLoanButton } from "./LoansSection.styles";

import Locale from "react-intl-universal";

const { confirm } = Modal;

const Loans = ({ onAddLoanButtonClick, loans, onEdit, onDelete }) => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <AddLoanButton icon={<PlusOutlined />} onClick={onAddLoanButtonClick}>
          {Locale.get("addNewAdvisee.loanSection.addLoanButton")}
        </AddLoanButton>
      </Col>
      {loans.map((loan, index) => (
        <Col span={12} key={index}>
          <LoanCard
            amount={loan.amount}
            loanType={loan.type}
            loanBalance={loan.loanBalance}
            isProtected={loan.isInsuranceCovered}
            onEditClick={() => onEdit(index)}
            onDeleteClick={() => onDelete(index)}
          />
        </Col>
      ))}
    </Row>
  );
};

const LoansSection = ({ onFieldFocus, loans, updateLoans }) => {
  const [showLoanModal, setShowLoanModal] = useState(false);
  const [isEditLoanClicked, setIsEditLoanClicked] = useState(false);
  const [selectedLoanIndex, setSelectedLoanIndex] = useState(-1);

  const handleOnAddLoanButtonClick = () => {
    setShowLoanModal(true);
    setIsEditLoanClicked(false);
    setSelectedLoanIndex(-1);
  };

  const handleOnEditLoanButtonClick = (index) => {
    setIsEditLoanClicked(true);
    setShowLoanModal(true);
    setSelectedLoanIndex(index);
  };

  const handleOnDeleteLoanButtonClick = (index) => {
    confirm({
      title: "Do you want to remove this loan?",
      okText: "Yes",
      onOk() {
        const newLoans = [...loans];
        newLoans.splice(index, 1);
        updateLoans(newLoans);
      },
      onCancel() {},
    });
  };

  const formatValues = (values) => {
    return {
      ...values,
      amount: values.amount && Number(values.amount),
      loanBalance: values.loanBalance && Number(values.loanBalance),
    };
  };

  const handleOnAddLoanModalOkButtonClick = (values) => {
    if (isEditLoanClicked) {
      let editedLoans = [...loans];
      editedLoans[selectedLoanIndex] = formatValues(values);
      updateLoans(editedLoans);
      setIsEditLoanClicked(false);
    } else {
      const newLoans = [...loans, formatValues(values)];
      updateLoans(newLoans);
    }
    setShowLoanModal(false);
  };

  const handleOnAddLoanModalCancelButtonClick = () => {
    setShowLoanModal(false);
  };

  return (
    <FormToggle
      label={Locale.get("addNewAdvisee.loanSection.toggleLabel_0")}
      name="hasPayment"
    >
      <Loans
        onAddLoanButtonClick={handleOnAddLoanButtonClick}
        loans={loans}
        onEdit={handleOnEditLoanButtonClick}
        onDelete={handleOnDeleteLoanButtonClick}
      />
      {showLoanModal && (
        <AddLoanModal
          defaultValues={selectedLoanIndex > -1 && loans[selectedLoanIndex]}
          onOk={handleOnAddLoanModalOkButtonClick}
          onCancel={handleOnAddLoanModalCancelButtonClick}
          visible={showLoanModal}
        />
      )}
    </FormToggle>
  );
};

export default LoansSection;
